import React, { useEffect, useState } from 'react';
import Footer from '../Header/Footer';
import Header from '../Header/Header';
import Config from '../Header/Config';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';



export default function PurchaseUpdate() {
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [date, setDate] = useState('');
  const [supplierName, setSupplierName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [address, setAddress] = useState('');
  const [modelName, setModelName] = useState('');
  const [color, setColor] = useState('');
  const [imei, setImei] = useState('');
  const [price, setPrice] = useState('');
  const [quantity, setQuantity] = useState('');
  let [subTotal, setSubTotal] = useState(0);
  let [balance, setBalance] = useState('');
  const [payableAmount, setPayableAmount] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [tableData, setTableData] = useState([]);
  const [editIndex, setEditIndex] = useState(null); // Track which Brand Details item is being edited
  const [newItems, setNewItems] = useState([]); // Track newly added items (without id)
  const [updatedItems, setUpdatedItems] = useState([]); // Track updated items (with id)
  const [deletedItems, setDeletedItems] = useState([]); // Track deleted items (with id) for DB deletion

  const [selectedRow, setSelectedRow] = useState(null); // New state to store the selected row
  //...........................................................................................................................................
  const apiUrl = Config.apiUrl;
  const navigate = useNavigate();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const invoice_Number = searchParams.get("invoice_no");

  const imeiParam = searchParams.get("id");
  const idParam = parseInt(imeiParam);



  //.........................................................................

  const handleBrandUpdate = async (row) => {
    const { id } = row;
    setSelectedRow(row);
    const queryParams = new URLSearchParams({
      invoice_no: invoice_Number,
      id: id, // Make sure to pass the correct 'id' value here
    });
    navigate(`/purchase_update?${queryParams}`);
  };
  //........................................................[supplier ,payment details].................................................................................
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_purchaseInvoice/${invoice_Number}`);

        const data = await response.json();
        const combineData = data.data
        setTableData(combineData)

        setInvoiceNumber(data.data[0].invoice_no);
        setDate(data.data[0].date);
        setSupplierName(data.data[0].supplier_name);
        setMobileNumber(data.data[0].mobile_no);
        setAddress(data.data[0].address);

        setPayableAmount(data.data[0].payable_amount);

        setPaymentMode(data.data[0].payment_mode);
        setSubTotal(data.data[0].sub_total)
        console.log(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [invoice_Number]);

  // ..........................[ Calculate Sub Total from tableData ].............................
  useEffect(() => {
    if (tableData && tableData.length > 0) {
      const total = tableData.reduce((sum, item) => {
        const purchasePrice = parseFloat(item.purchase_price) || 0;
        return sum + purchasePrice;
      }, 0);
      setSubTotal(total);
    } else {
      setSubTotal(0);
    }
  }, [tableData]);

  //........................................[ fetch data for brand table].....................................................................................................



  //...................................................[ Update brand Items].....................................................................................
  const [showBrandListTable, setShowBrandListTable] = useState(true); // Default: show the table

  // Handle Edit for Brand Details
  const handleEdit = (index) => {
    const item = tableData[index];
    if (item) {
      setEditIndex(index);
      setModelName(item.model_name || "");
      setColor(item.color || "");
      setImei(item.imei || "");
      setPrice(item.purchase_price ? item.purchase_price.toString() : "");
      setQuantity(item.sale_price ? item.sale_price.toString() : "");
      alert("Editing item. Make changes and click Update to save.");
    }
  };

  // Cancel Edit for Brand Details
  const handleCancelEdit = () => {
    setEditIndex(null);
    setModelName("");
    setImei("");
    setColor("");
    setQuantity("");
    setPrice("");
  };

  const updateBrandDetails = () => {
    const item = {
      model_name: modelName,
      color: color,
      imei: imei,
      purchase_price: price,
      sale_price: quantity,
    };

    if (editIndex !== null) {
      // Update existing item in array
      const updatedTableData = [...tableData];
      const existingItem = updatedTableData[editIndex];
      item.id = existingItem.id; // Preserve existing ID
      item.invoice_no = invoice_Number; // Preserve invoice_no
      updatedTableData[editIndex] = item;
      setTableData(updatedTableData);

      // Track for batch update
      setUpdatedItems((prev) => {
        const filtered = prev.filter((i) => i.id !== item.id);
        return [...filtered, item];
      });
      
      // Remove from newItems if it was there
      setNewItems((prev) => prev.filter((i) => 
        i.imei !== item.imei || i.model_name !== item.model_name
      ));

      alert("Item updated in list. Click Update button to save changes.");
      setEditIndex(null);
    } else {
      // Add new item to the list (no ID yet)
      const newItem = { ...item, invoice_no: invoice_Number };
      setTableData((prev) => [...prev, newItem]);
      setNewItems((prev) => [...prev, newItem]);
      alert("Item added to list. Click Update button to save changes.");
    }

    // Clear form fields
    setModelName("");
    setImei("");
    setColor("");
    setQuantity("");
    setPrice("");
  };


  //.........................................[ update purchaseDetails ].......................................

  const [updatedDetails, setUpdatedDetails] = useState([])
  const updatepurchaseDetails = async () => {
    const item = {
      date: date,
      supplier_name: supplierName,
      mobile_no: mobileNumber,
      address: address,
      sub_total: subTotal,
      balance_amount: "0",
      payable_amount: "0",
      payment_mode: "0"

    };

    try {
      // Step 1: Update Purchase Details
      const result = await fetch(`${apiUrl}/update_purchaseDetails/${invoice_Number}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });

      if (!result.ok) {
        let errorMessage = "Failed to update Purchase Details";
        try {
          const errorData = await result.json();
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.data && errorData.data.message) {
            errorMessage = errorData.data.message;
          }
        } catch (parseError) {
          errorMessage = `Error ${result.status}: ${result.statusText || "Failed to update Purchase Details"}`;
        }
        alert(errorMessage);
        console.error("API Error:", errorMessage);
        return;
      }

      // Step 2: Update existing items
      if (updatedItems && updatedItems.length > 0) {
        console.log(`Updating ${updatedItems.length} items...`);
        const updatePromises = updatedItems.map((item) => {
          console.log(`Updating item:`, item);
          return fetch(`${apiUrl}/update_purchaseItem/${item.id}/${invoice_Number}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(item),
          });
        });

        const updateResults = await Promise.all(updatePromises);
        const failedResults = updateResults.filter((result) => !result.ok);
        
        if (failedResults.length > 0) {
          let errorMessages = [];
          for (const failedResult of failedResults) {
            try {
              const errorData = await failedResult.json();
              errorMessages.push(errorData.message || errorData.error || "Failed to update item");
            } catch (parseError) {
              errorMessages.push(`Error ${failedResult.status}: ${failedResult.statusText || "Failed to update item"}`);
            }
          }
          alert(`Failed to update some items:\n${errorMessages.join("\n")}`);
          console.error("Update Items Error:", errorMessages);
          return;
        }
        console.log(`Successfully updated ${updatedItems.length} items`);
      }

      // Step 3: Add new items
      if (newItems && newItems.length > 0) {
        console.log(`Adding ${newItems.length} new items...`);
        const addPromises = newItems.map((item) => {
          console.log(`Adding new item:`, item);
          return fetch(`${apiUrl}/purchase_items`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(item),
          });
        });

        const addResults = await Promise.all(addPromises);
        const failedAddResults = addResults.filter((result) => !result.ok);
        
        if (failedAddResults.length > 0) {
          let errorMessages = [];
          for (const failedResult of failedAddResults) {
            try {
              const errorData = await failedResult.json();
              errorMessages.push(errorData.message || errorData.error || "Failed to add item");
            } catch (parseError) {
              errorMessages.push(`Error ${failedResult.status}: ${failedResult.statusText || "Failed to add item"}`);
            }
          }
          alert(`Failed to add some new items:\n${errorMessages.join("\n")}`);
          console.error("Add Items Error:", errorMessages);
          return;
        }
        console.log(`Successfully added ${newItems.length} new items`);
      }

      // Step 4: Delete items that were removed
      if (deletedItems && deletedItems.length > 0) {
        console.log(`Deleting ${deletedItems.length} items...`);
        const deletePromises = deletedItems.map((id) => {
          console.log(`Deleting item with id ${id}`);
          return fetch(`${apiUrl}/delete_purchaseItems/${id}`, {
            method: "DELETE",
          });
        });

        const deleteResults = await Promise.all(deletePromises);
        const failedDeleteResults = deleteResults.filter((result) => !result.ok);
        
        if (failedDeleteResults.length > 0) {
          let errorMessages = [];
          for (const failedResult of failedDeleteResults) {
            try {
              const errorData = await failedResult.json();
              errorMessages.push(errorData.message || errorData.error || "Failed to delete item");
            } catch (parseError) {
              errorMessages.push(`Error ${failedResult.status}: ${failedResult.statusText || "Failed to delete item"}`);
            }
          }
          alert(`Failed to delete some items:\n${errorMessages.join("\n")}`);
          console.error("Delete Items Error:", errorMessages);
          return;
        }
        console.log(`Successfully deleted ${deletedItems.length} items`);
      }

      // All updates successful
      alert("Purchase Details updated successfully");
      
      // Clear states
      setNewItems([]);
      setUpdatedItems([]);
      setDeletedItems([]);
      setEditIndex(null);

      // Navigate back to previous page
      setTimeout(() => {
        navigate(-1);
      }, 500); // Small delay to show success message

    } catch (error) {
      console.error("Network/Request Error:", error);
      let errorMessage = "Failed to update Purchase Details";
      
      if (error.message) {
        errorMessage = error.message;
      } else if (error.name === "TypeError" && error.message.includes("fetch")) {
        errorMessage = "Network Error: Unable to connect to server. Please check your internet connection or CORS settings.";
      } else if (error.name === "TypeError") {
        errorMessage = `Network Error: ${error.message}`;
      }
      
      alert(errorMessage);
    }
  };

  //.........................................[ delete purchaseDetails ].......................................
  
  const deletePurchaseDetails = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Purchase Details record? This action cannot be undone."
    );

    if (!confirmDelete) {
      return;
    }

    try {
      const result = await fetch(`${apiUrl}/delete_purchaseDetails/${invoice_Number}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!result.ok) {
        let errorMessage = "Failed to delete Purchase Details";
        try {
          const errorData = await result.json();
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.data && errorData.data.message) {
            errorMessage = errorData.data.message;
          }
        } catch (parseError) {
          errorMessage = `Error ${result.status}: ${result.statusText || "Failed to delete Purchase Details"}`;
        }
        alert(errorMessage);
        console.error("API Error:", errorMessage);
        return;
      }

      // Success
      alert("Purchase Details deleted successfully");
      
      // Navigate back to previous page
      setTimeout(() => {
        navigate(-1);
      }, 500);

    } catch (error) {
      console.error("Network/Request Error:", error);
      let errorMessage = "Failed to delete Purchase Details";
      
      if (error.message) {
        errorMessage = error.message;
      } else if (error.name === "TypeError" && error.message.includes("fetch")) {
        errorMessage = "Network Error: Unable to connect to server. Please check your internet connection or CORS settings.";
      } else if (error.name === "TypeError") {
        errorMessage = `Network Error: ${error.message}`;
      }
      
      alert(errorMessage);
    }
  };
  //...........................................................................................


  // Delete Record - Remove from array (will be deleted from DB on final submit if has id)
  const handleDelete = (id, index) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this item from the list?"
    );

    if (confirmDelete) {
      const itemToDelete = tableData[index];
      
      // Remove from array
      setTableData((preData) => preData.filter((_, i) => i !== index));
      
      // If item has id, track for deletion from DB
      if (id) {
        setDeletedItems((prev) => [...prev, id]);
        // Remove from updatedItems if it was there
        setUpdatedItems((prev) => prev.filter((item) => item.id !== id));
      } else {
        // Remove from newItems if it was there (no id means it's a new item)
        setNewItems((prev) => prev.filter((item) => 
          item.imei !== itemToDelete.imei || 
          item.model_name !== itemToDelete.model_name
        ));
      }

      alert("Item removed from list. Click Update button to save changes.");
    }
  };

  //.............................


  const [modelList, setModelList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_models`);
        const data = await response.json();
        setModelList(data.data);
        console.log(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Purchase Details</h4>
                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 heading-heighlight">Supplier Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3" style={{ display: 'none' }}>
                        <label className="form-label" htmlFor="basic-default-fullname">
                          Invoice Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="basic-default-fullname"
                          placeholder="Enter Invoice Number"
                          value={invoiceNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            setInvoiceNumber(value);
                          }}
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-company">
                          Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          id="basic-default-date"
                          placeholder="Enter date"
                          value={date}
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-email">
                          Supplier Name
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type="text"
                            id="basic-default-email"
                            className="form-control"
                            placeholder="Enter Supplier Name"
                            aria-label="john.doe"
                            aria-describedby="basic-default-email2"
                            value={supplierName}
                            onChange={(e) => setSupplierName(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-phone">
                          Mobile Number
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Mobile Number"
                          value={mobileNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                            setMobileNumber(value);
                          }}
                          maxLength={10}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-phone">
                          Address
                        </label>
                        <textarea
                          id="basic-default-message"
                          className="form-control"
                          placeholder="Enter Address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          rows={1}
                        />
                      </div>
                      <hr className="mb-3 mt-3" />

                      <h5 className="mb-4 heading-heighlight">Brand Details</h5>
                      <div className="col-md-6 mb-3">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label" htmlFor="basic-default-company">
                              Model Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              list="browsers"
                              name="browser"
                              id="browser"
                              placeholder="Enter Model Name"
                              value={modelName}
                              onChange={(e) => setModelName(e.target.value)}
                            />
                            <datalist id="browsers">
                              {modelList.map((model, index) => (
                                <option key={index} value={model.model_name} />
                              ))}
                            </datalist>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label" htmlFor="basic-default-company">
                              Color
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="basic-default-company"
                              list="color-options"
                              placeholder="Enter Color"
                              value={color}
                              onChange={(e) => setColor(e.target.value)}
                            />
                            <datalist id="color-options">
                              <option value="Black" />
                              <option value="White" />
                              <option value="Blue" />
                              <option value="Yellow" />
                              <option value="Coral" />
                              <option value="RED" />
                              <option value="Purple" />
                              <option value="Green" />
                              <option value="Starlight" />
                              <option value="Midnight" />
                              <option value="Pink" />
                              <option value="Teal" />
                              <option value="Ultramarine" />
                              <option value="Mist Blue" />
                              <option value="Sage" />
                              <option value="Lavender" />
                              <option value="Silver" />
                              <option value="Space Gray" />
                              <option value="Gold" />
                              <option value="Midnight Green" />
                              <option value="Graphite" />
                              <option value="Pacific Blue" />
                              <option value="Sierra Blue" />
                              <option value="Alpine Green" />
                              <option value="Space Black" />
                              <option value="Deep Purple" />
                              <option value="Black Titanium" />
                              <option value="White Titanium" />
                              <option value="Blue Titanium" />
                              <option value="Natural Titanium" />
                              <option value="Desert Titanium" />
                              <option value="Cosmic Orange" />
                              <option value="Deep Blue" />
                            </datalist>
                          </div>


                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-phone">
                          IMEI
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter IMEI"
                          value={imei}
                          style={{ textTransform: 'uppercase' }}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase();
                            setImei(value);
                          }}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-phone">
                          Purchase Price
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Price"
                          value={price}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setPrice(value);
                          }}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-phone">
                          Sale Price
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Sale Price"
                          value={quantity}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setQuantity(value);
                          }}
                        />
                      </div>
                      <div className="col-12">
                          <div className="col-12 d-flex justify-content-end">
                            {editIndex !== null && (
                              <button
                                type="button"
                                className="btn btn-secondary"
                                style={{ marginLeft: "5px", marginRight: "5px" }}
                                onClick={handleCancelEdit}
                              >
                                Cancel
                              </button>
                            )}
                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", marginRight: "5px" }}
                              onClick={() => updateBrandDetails()}
                              disabled={editIndex === null}
                            >
                              Update
                            </button>
                        </div>
                        {showBrandListTable && (
                          <div className="card mt-3">
                            <h5 className="card-header heading-heighlight">Brand List</h5>
                            <div className="table-responsive text-nowrap">
                              <table className="table">
                                <thead>
                                  <tr className="text-nowrap">
                                    <th>SN</th>
                                    <th>Model Name</th>
                                    <th>IMEI</th>
                                    <th>Color</th>
                                    <th>Purchase Price</th>
                                    <th>Sale Price</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tableData.map((row, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{row.model_name}</td>
                                      <td>{row.color}</td>
                                      <td>{row.imei}</td>
                                      <td>{row.purchase_price}</td>
                                      <td>{row.sale_price}</td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-sm me-1"
                                          onClick={() => handleEdit(index)}
                                          style={{ marginRight: "5px" }}
                                          title="Edit"
                                        >
                                          <FaEdit />
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() => handleDelete(row.id, index)}
                                          title="Delete"
                                        >
                                          <FaTrashAlt />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>

                      <hr className="mb-3 mt-3" />
                      <h5 className="mb-4 heading-heighlight">Payment Details</h5>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-company">
                          Sub Total
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Sub Total"
                          readOnly
                          value={subTotal}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setSubTotal(value);
                          }}
                        />
                      </div>
                      {/* <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-phone">
                          Payable Amount
                        </label>
                        <input
                          type="number"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Payable Amount"
                          value={payableAmount}
                          onChange={(e) => setPayableAmount(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-company">
                          Balance
                        </label>
                        <input
                          type="number"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Balance"
                          value={
                            (balance =
                              Number(subTotal) -
                              Number(payableAmount))
                          }
                          onChange={(e) => setBalance(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-phone">
                          Payment Mode
                        </label>
                        <select
                          className="form-select"
                          id="basic-default-company"
                          value={paymentMode}
                          onChange={(e) => setPaymentMode(e.target.value)}
                        >
                          <option value="" disabled>
                            Select Payment Mode
                          </option>
                          <option value="Credit Card">Credit Card</option>
                          <option value="Debit Card">Debit Card</option>
                        </select>
                      </div> */}
                      <div className="col-12 d-flex justify-content-end">
                        {tableData.length === 0 ? (
                          <button
                            type="button"
                            className="btn btn-danger"
                            style={{ marginLeft: '5px', marginRight: '5px' }}
                            onClick={() => deletePurchaseDetails()}
                          >
                            Delete
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{ marginLeft: '5px', marginRight: '5px' }}
                            onClick={() => updatepurchaseDetails()}
                          >
                            Update
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
